import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";

export default makeStyles((theme: Theme) => ({
  paper: {
    width: 514,
    maxWidth: "calc(100vw - 32px)",
    padding: theme.spacing(2),
    boxShadow: "2px 4px 7px 0px rgba(0, 0, 0, 0.12)",
  },
  popoverPaper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    marginTop: theme.spacing(1),
    overflow: "visible",
  },
  iframeLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: "#2979FF",
    textTransform: "uppercase" as const,
    letterSpacing: "1.2px",
    marginBottom: theme.spacing(2),
  },
  pendingAlert: {
    marginBottom: theme.spacing(2),
  },
  verificationUrlField: {
    marginBottom: `${theme.spacing(1)}px !important`,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#FF9800 !important",
      },
      "&:hover fieldset": {
        borderColor: "#FF9800 !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#FF9800 !important",
      },
    },
    "& .MuiFormLabel-root": {
      color: "#FF9800 !important",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#FF9800 !important",
    },
    "& .MuiFormHelperText-root": {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0),
    },
  },
  verificationHelper: {
    display: "block",
    color: "#FF9800",
    fontSize: 12,
    marginBottom: theme.spacing(2.25),
  },
  sizeRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(3),
  },
  sizeToggle: {
    display: "flex",
    alignItems: "center",
    height: 48,
    gap: theme.spacing(0.5),
    flexShrink: 0,
  },
  sizeToggleLabel: {
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap" as const,
    transition: "color 150ms",
  },
  sizeInputWrap: {
    width: 103,
    flexShrink: 0,
  },
  sizeField: {
    "& .MuiOutlinedInput-root": {
      height: 48,
    },
  },
  pixelInputs: {
    display: "flex",
    gap: theme.spacing(2),
    flex: 1,
  },
  statusWrap: {
    marginTop: theme.spacing(1.5),
  },
  alert: {
    marginTop: 0,
    marginBottom: theme.spacing(2),
  },
  helper: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
  approvedRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.5),
  },
  rejectedAlert: {
    backgroundColor: "#FFEBEE",
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  rejectedIcon: {
    color: "#F44336",
    flexShrink: 0,
  },
  rejectedText: {
    fontSize: 14,
    color: "#424242",
    lineHeight: 1.5,
    flex: 1,
  },
  verificationAlert: {
    minHeight: 67,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2.5),
    backgroundColor: "#FFF3E0",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2, 2.5),
    marginBottom: theme.spacing(2),
  },
  verificationIcon: {
    color: "#FF9800",
    fontSize: 28,
    flexShrink: 0,
  },
  verificationAlertText: {
    color: "#424242",
    fontSize: 14,
    fontWeight: 400,
  },
  verificationSnackbar: {
    backgroundColor: "#424242",
    color: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.50), 0 4px 8px 0 rgba(0, 0, 0, 0.15)",
    padding: theme.spacing(2.5, 3),
  },
  verificationSnackbarMessage: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2.5),
    padding: 0,
  },
  verificationSnackbarIcon: {
    color: blue.A100,
    fontSize: 24,
    flexShrink: 0,
  },
  verificationSnackbarText: {
    color: theme.palette.common.white,
    fontSize: 14,
    lineHeight: "28px",
  },
  pendingRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: grey[700],
    cursor: "pointer",
    padding: theme.spacing(1, 2),
    backgroundColor: blue[50],
    fontSize: 14,
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    borderRadius: "8px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: 0,
  },
  actionBtn: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: "uppercase" as const,
    padding: theme.spacing(1, 1),
    minWidth: "auto",
  },
  endAdornmentSpinner: {
    marginRight: theme.spacing(0.5),
  },
}));
